import { useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconHomeQuestion } from '@tabler/icons'
import { useRouter } from 'next/router'
import React from 'react'

import { Breadcrumbs } from '@/components/ui/navigation/Breadcrumbs'
import { useFetch } from '@/lib/hooks'
import { Breadcrumb as BreadcrumbType, Site as SiteType } from '@/types'

interface Props {
  siteData?: SiteType
  children?: React.ReactNode
}

export default function BreadcrumbNav({ siteData }: Props) {
  // Hooks
  const theme = useMantineTheme()
  const isXs = useMediaQuery(`(max-width: ${theme.breakpoints.xs}px)`)
  const router = useRouter()

  // Constants
  const { articleSlug, site, sectionSlug, ticketId } = router.query || {}
  const paths = router.asPath.split('/')
  const helpPath = '/_sites/[site]/help'

  const { data: sectionData } = useFetch([sectionSlug ? `${site}/kb/sections/${sectionSlug}/` : null])

  const breadcrumbsItems:BreadcrumbType[] = [
    {
      title: 'Central de Ajuda',
      href: '/help',
      icon: <IconHomeQuestion size={isXs ? 14 : 18} />,
      isActive: router?.pathname === helpPath
    }
  ]
  if (paths.indexOf('contacts') >= 0) {
    breadcrumbsItems.push({
      title: 'Fale Conosco',
      href: '/help/contacts',
      isActive: router?.pathname === `${helpPath}/contacts`
    })
  }
  if (paths.indexOf('articles') >= 0) {
    breadcrumbsItems.push({
      title: 'Tópicos de Ajuda',
      href: '/help/articles',
      isActive: router?.pathname === `${helpPath}/articles`
    })
    if (sectionSlug) {
      breadcrumbsItems.push({
        title: sectionData?.name,
        href: `/help/articles/${sectionData?.slug}`,
        isActive: router?.pathname === `${helpPath}/articles/[sectionSlug]`
      })
      if (articleSlug) {
        breadcrumbsItems.push({
          title: 'Artigo',
          href: `/help/articles/${sectionData?.slug}/article`,
          isActive: router?.pathname === `${helpPath}/articles/[sectionSlug]/[articleSlug]`
        })
      }
    }
  }
  if (paths.indexOf('tickets') >= 0) {
    breadcrumbsItems.push({
      title: 'Atendimentos',
      href: '/help/tickets',
      isActive: router?.pathname === `${helpPath}/tickets`
    })
    if (ticketId) {
      breadcrumbsItems.push({
        title: `Atendimento #${ticketId}`,
        href: `/help/tickets/${ticketId}`,
        isActive: router?.pathname === `${helpPath}/tickets/[ticketId]`
      })
    }
  }

  return (
    <Breadcrumbs
      breadcrumbs={breadcrumbsItems.filter(item => Boolean(item.title))}
    />
  )
}
